import React, { useState, FormEvent, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form'

import svgWait2 from './svg/wait2.gif'


import { CBBCConfig } from './Types'
import { SystemHeader } from './CommonUI';

import { transpileModule } from 'typescript';
import { stringify } from 'querystring';

var showFeeSection:boolean = true ;
var showDividendSection:boolean = true ;
var showFRRSection:boolean = true ;
var showStampReturnSection:boolean = true ;
var showAutopaySection:boolean = true ;


interface PageInfo {
    n: number
}

var GsbFlag: any;


interface CBBCConfigViewProps {
    gsb: AxiosInstance,
    CBBCConfig: CBBCConfig,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}



function CBBCConfigView({ gsb, CBBCConfig = {} as CBBCConfig, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: CBBCConfigViewProps) {

    const [isDeletePress, setisDeletePress] = useState(false)

    const [showFeeSectionMore, setshowFeeSectionMore] = useState(showFeeSection)
    const [showDividendSectionMore, setshowDividendSectionMore] = useState(showDividendSection)
    const [showFRRSectionMore, setshowFRRSectionMore] = useState(showFRRSection)
    const [showStampReturnSectionMore, setshowStampReturnSectionMore] = useState(showStampReturnSection)
    const [showAutopaySectionMore, setshowAutopaySectionMore] = useState(showAutopaySection)
    
    const [userKey, setuserKey] = useState("DEMO")
    const [GSBx_USER, setGSBx_USER] = useState(false)
    const [dateFormat, setdateFormat] = useState("1")


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                setuserKey(GsbFlag.user_key)
                setGSBx_USER(GsbFlag.GSBx_USER) ;
                setdateFormat(GsbFlag.dateFormat)
            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, CBBCConfig ])



    if (!("d_tr_date" in CBBCConfig)) return null



    return (
        <div>
            <div className="Row">
                <Button className="Col-1-1" disabled={true} icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                <Button className="Col-2-1" disabled={true} icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" disabled={true} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>

                <Button className="Col-5-1" disabled={true} icon="direction-right" onClick={() => onNextRec()} >Next</Button>
             
            </div>
            <div className="Spacing-V-16" />

 
            <div className="Spacing-V-16" />
            { GSBx_USER && <div>
                <div className="Spacing-V-16" />
                <div className="Row">
                    <FormGroup className="Col-1-3" label="Original CA Fee( /lot)" labelInfo="">
                        <InputGroup readOnly value={utils.ParseFloat(CBBCConfig.x_CBBC_CAFEE,2)} />
                    </FormGroup>

                    <FormGroup className="Col-1-3" label="Minimum CA Fee" labelInfo="">
                        <InputGroup readOnly value={utils.ParseFloat(CBBCConfig.x_CBBC_MINFEE,2)} />
                    </FormGroup>
                    <FormGroup className="Col-1-3" label="Maximum CA Fee" labelInfo="">
                        <InputGroup readOnly value={utils.ParseFloat(CBBCConfig.x_CBBC_MAXFEE,2)} />
                    </FormGroup>
                </div>
                <div className="Row">
                    <FormGroup className="Col-1-3" label="Original Handling Fee( /lot)" labelInfo="">
                        <InputGroup readOnly value={utils.ParseFloat(CBBCConfig.x_CB_HAND,2)} />
                    </FormGroup>

                    <FormGroup className="Col-1-3" label="Minimum Handling Fee" labelInfo="">
                        <InputGroup readOnly value={utils.ParseFloat(CBBCConfig.x_CB_MINHAND,2)} />
                    </FormGroup>
                    <FormGroup className="Col-1-3" label="Maximum Handling Fee" labelInfo="">
                        <InputGroup readOnly value={utils.ParseFloat(CBBCConfig.x_CB_MAXHAND,2)} />
                    </FormGroup>
                </div>
 
                <div className="Row">
                    <FormGroup className="Col-1-4" label="Calculate Stamp Amount" labelInfo="">
                        <RadioGroup
                            name="x_CAL_STM"
                            disabled={true}
                            inline={true}
                            selectedValue={CBBCConfig.x_CAL_STM}
                            onChange={(s) => { }}
                        >
                            <Radio label="Yes" value="Y" />
                            <Radio label="No"  value="N" />
                        </RadioGroup>
                    </FormGroup>
                </div>
 
                <div className="Spacing-V-16" />
                <div className="Row">
                    <FormGroup className="Col-1-4" label="Generate Payment/Receipt Transaction For Negative Amount (Y/N)" labelInfo="">
                        <RadioGroup
                            name="x_GEN_NEG"
                            disabled={true}
                            inline={true}
                            selectedValue={CBBCConfig.x_GEN_NEG}
                            onChange={(s) => { }}
                        >
                            <Radio label="Yes" value="Y" />
                            <Radio label="No" value="N" />
                        </RadioGroup>
                    </FormGroup>
                </div>
           
            
            </div> }
          
 
             {/*  
             <div className="Row">
                <FormGroup className="Col-1-2" label="Enter to next input field" labelFor="inputEnter2Tab">
                    <RadioGroup
                        name="d_Enter2Tab"
                        disabled={true}
                        inline={true}
                        selectedValue={GsbConfig.d_Enter2Tab}
                        onChange={(s) => { }}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
                </FormGroup>
            </div>
            */}
        </div>
    )
}

interface CBBCConfigEditProps {
    gsb: AxiosInstance,
    CBBCConfig?: CBBCConfig,
    isNew?: boolean,
    onSave?: (CBBCConfig: CBBCConfig) => void,
    onCancel?: () => void;
}

// onChange={utils.handleStringChange(s => setAc(prevState => Object.assign(prevState, {acName1: s})))}
function CBBCConfigEdit({ gsb, CBBCConfig = {} as CBBCConfig, isNew = false, onSave = () => { }, onCancel = () => { } }: CBBCConfigEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<CBBCConfig>()

    const [showFeeSectionMore, setshowFeeSectionMore] = useState(showFeeSection)
    const [showDividendSectionMore, setshowDividendSectionMore] = useState(showDividendSection)
    const [showFRRSectionMore, setshowFRRSectionMore] = useState(showFRRSection)
    const [showStampReturnSectionMore, setshowStampReturnSectionMore] = useState(showStampReturnSection)
    const [showAutopaySectionMore, setshowAutopaySectionMore] = useState(showAutopaySection)
 
    //Calculate Stamp Amoun -->CBBC

    //const [CBBC_CaFeeValue, setCBBC_CaFeeValue] = useState(utils.numToString3 (GsbConfig.x_CBBC_CAFEE,2))

 
    const [CBBC_CAFEEValue, setCBBC_CAFEEValue] = useState(utils.ParseFloat(CBBCConfig.x_CBBC_CAFEE,2))
 

    const [CBBC_CAMinFeeValue, setCBBC_CAMinFeeValue] = useState(utils.ParseFloat(CBBCConfig.x_CBBC_MINFEE, 2))
    const [CBBC_CAMaxFeeValue, setCBBC_CAMaxFeeValue] = useState(utils.ParseFloat(CBBCConfig.x_CBBC_MAXFEE, 2))
    const [CBBC_CBHandValue, setCBBC_CBHandValue] = useState(utils.ParseFloat(CBBCConfig.x_CB_HAND, 2))
    const [CBBC_CBMinValue, setCBBC_CBMinValue] = useState(utils.ParseFloat(CBBCConfig.x_CB_MINHAND, 2))
    const [CBBC_CBMaxValue, setCBBC_CBMaxValue] = useState(utils.ParseFloat(CBBCConfig.x_CB_MAXHAND, 2))
    const [CalStampAmValue, setCalStampAmtValue] = useState(CBBCConfig.x_CAL_STM)

    const [GenNegValue, setGenNegValue] = useState(CBBCConfig.x_GEN_NEG)

    const [userKey, setuserKey] = useState("DEMO")
    const [GSBx_USER, setGSBx_USER] = useState(false)
    const [dateFormat, setdateFormat] = useState("1")
   // const [def_d_theme1, setdef_d_theme1] = useState(GsbConfig.d_theme1)
   // const [def_d_theme2, setdef_d_theme2] = useState(GsbConfig.d_theme2)
   // const [def_Enter2Tab, setdef_Enter2Tab] = useState(GsbConfig.d_Enter2Tab)

  
 
    useEffect(() => {
        // Call reset to set default values if ac is passed
        if ("d_tr_date" in CBBCConfig) {
            reset(CBBCConfig)
        }
    }, [CBBCConfig, reset])

 

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                setuserKey(GsbFlag.user_key)
                setGSBx_USER(GsbFlag.GSBx_USER) ;
                setdateFormat(GsbFlag.dateFormat)

            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, CBBCConfig])


    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        //register({ name: "d_status" })
    }, [register])

    
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
    

    if (!isNew && !("d_tr_date" in CBBCConfig)) return null


    const onSubmit = (data: CBBCConfig) => {
 
 

        data.x_CBBC_CAFEE = CBBC_CAFEEValue;
        data.x_CBBC_MINFEE = CBBC_CAMinFeeValue;
        data.x_CBBC_MAXFEE = CBBC_CAMaxFeeValue;
        data.x_CB_HAND = CBBC_CBHandValue;
        data.x_CB_MINHAND = CBBC_CBMinValue;
        data.x_CB_MAXHAND = CBBC_CBMaxValue;
        data.x_CAL_STM = CalStampAmValue;
        data.x_GEN_NEG = GenNegValue;
      
        ;
        (async () => {
            try {
                //console.log("call CBBCConfigEdit data", data)
                //console.log("call CBBCConfigEdit isNew", isNew)
                const res = await gsb.post('/Master', {sb_data: data, cPgmId: "CBBCConfig", cAction: "CBBCConfigValidate", isNew: isNew})
                //console.log("CBBCConfigEdit res.data.ok", res.data.ok)
                console.log("CBBCConfigEdit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }
                    return
                }

                onSave(data)

            } catch (error) {
                utils.showError(error)
                //showErrorBox(error)
            }
        })()

    }



    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                {/*<Button className="Col-2-1" icon="undo" onClick={() => reset(ac)}>Reset</Button>*/}
                {/*<Button className="Col-3-1" icon="tick" type="submit">Save</Button>*/}
            </div>
            <div className="Spacing-V-16" />
            <div className="Spacing-V-16" />
            <div className="Spacing-V-16" />

      
            <div className="Row">
                <FormGroup className="Col-1-3" label="Original CA Fee( /lot)" labelInfo="">
                    <InputGroup id="inputCaFee" name="x_CBBC_CAFEE" defaultValue={CBBC_CAFEEValue} value={CBBC_CAFEEValue} onChange={utils.handleStringChange(n => setCBBC_CAFEEValue(n))} ref={register} />
                    {errors.x_CBBC_CAFEE && errors.x_CBBC_CAFEE.types && <span id="Err_msg">{errors.x_CBBC_CAFEE.types.message}</span>}
   
                
                </FormGroup>
 
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="Minimum CA Fee" labelInfo="">
                    <InputGroup id="inputCaMinfee" name="x_CBBC_MINFEE" defaultValue={CBBC_CAMinFeeValue} value={CBBC_CAMinFeeValue} onChange={utils.handleStringChange(n => setCBBC_CAMinFeeValue(n))} ref={register} />
                    {errors.x_CBBC_MINFEE && errors.x_CBBC_MINFEE.types && <span id="Err_msg">{errors.x_CBBC_MINFEE.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="Maximum CA Fee" labelInfo="">
                    <InputGroup id="inputCaMaxFee" name="x_CBBC_MAXFEE"  defaultValue={CBBC_CAMaxFeeValue} value={CBBC_CAMaxFeeValue} onChange={utils.handleStringChange(n => setCBBC_CAMaxFeeValue(n))} ref={register} />
                    {errors.x_CBBC_MAXFEE && errors.x_CBBC_MAXFEE.type === "min" && <span id="Err_msg">Fixed Comm Amount sholud be greater than 0 </span>}
                    {errors.x_CBBC_MAXFEE && errors.x_CBBC_MAXFEE.types && <span id="Err_msg">{errors.x_CBBC_MAXFEE.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="Original Handling Fee" labelInfo="">
                    <InputGroup id="inputHandFee" name="x_CB_HAND" defaultValue={CBBC_CBHandValue} value={CBBC_CBHandValue} onChange={utils.handleStringChange(n => setCBBC_CBHandValue(n))} ref={register} />
              
                    {errors.x_CB_HAND && errors.x_CB_HAND.types && <span id="Err_msg">{errors.x_CB_HAND.types.message}</span>}
                </FormGroup>
            </div>

            <div className="Row">
                <FormGroup className="Col-1-3" label="Minimum Handling Fee" labelInfo="">
                    <InputGroup id="inputMinHandFee" name="x_CB_MINHAND" defaultValue={CBBC_CBMinValue} value={CBBC_CBMinValue} onChange={utils.handleStringChange(n => setCBBC_CBMinValue(n))} ref={register} />
                        {errors.x_CB_MINHAND && errors.x_CB_MINHAND.types && <span id="Err_msg">{errors.x_CB_MINHAND.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-3" label="Maximum Handling Fee" labelInfo="">
                    <InputGroup id="inputMaxHandFee" name="x_CB_MAXHAND" defaultValue={CBBC_CBMaxValue} value={CBBC_CBMaxValue} onChange={utils.handleStringChange(n => setCBBC_CBMaxValue(n))} ref={register} />
             
                    {errors.x_CB_MAXHAND && errors.x_CB_MAXHAND.types && <span id="Err_msg">{errors.x_CB_MAXHAND.types.message}</span>}
                </FormGroup>
            </div>
                               
            <div className="Spacing-V-16" />     
 
            <div className="Row">
                <FormGroup className="Col-1-4" label="Calculate Stamp Amount (Y/N)" labelInfo="">
                    <RadioGroup
                        name="x_CAL_STM"
                        inline={true}
                        selectedValue={CalStampAmValue}
                        onChange={utils.handleStringChange(s => setCalStampAmtValue(s)) }
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No"  value="N" />
                    </RadioGroup>
             
                </FormGroup>
            </div>
 
            <div className="Row">
                <FormGroup className="Col-1-4" label=" Generate Payment/Receipt Transaction For Negative Amount (Y/N)" labelInfo="">
                    <RadioGroup
                        name="x_GEN_NEG"
                        inline={true}
                        selectedValue={GenNegValue}
                        onChange={utils.handleStringChange(s => setGenNegValue(s))}
                        ref={register}
                    >
                        <Radio label="Yes" value="Y" />
                        <Radio label="No" value="N" />
                    </RadioGroup>
                    {errors.x_GEN_NEG && errors.x_GEN_NEG.types && <span id="Err_msg">{errors.x_GEN_NEG.types.message}</span>}
                </FormGroup>
            </div>
        </form>
    )
}

interface CBBCConfigMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function CBBCConfigMain({ gsb }: CBBCConfigMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [data, setData] = useState([] as CBBCConfig[])


    const [searchKey, setSearchKey] = useState("OpenDate")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(false)
    const [showButton, setshowButton] = useState(false)


    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("Detail")
    const [currentAc, setCurrentAc] = useState({} as CBBCConfig)
    const [BlankAc, setBlankAc] = useState({} as CBBCConfig)


    const [currentMode, setCurrentMode] = useState("show")

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    

    
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    //gsb default value
    //BlankAc.d_p_Pref = "P"



    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("GsbxConfigMain disp user_key: ", res.data.Flag.user_key)
                //console.log("GsbxConfigMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("GsbxConfigMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("GsbxConfigMain disp GsbFlag: ", GsbFlag)
                //console.log("GsbxConfigMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("GsbxConfigMain disp dateFormat: ", dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("GsbxConfigMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("GsbxConfigMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("GsbxConfigMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key) ;

                //console.log("GsbxConfigMain isProduction: ", GsbFlag.isProduction)
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                //console.log("set StatusList: ", StatusList)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb, currentMode])


    useEffect(() => {

        console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }


    }, [gsb, GsbFlag, cardOpen01, currentMode])


    useEffect(() => {

        setnPage(1)
        if ( nPage > 0 ) {
            //setcPrintMode("PS")
        } 

        (async () => {
            try {
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "CBBCConfig",
                        cAction: "ListRec",
                    });
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }

                console.log("main CBBCConfig ListRec res.data", res.data.data)
                console.log("main CBBCConfig", currentAc)
                setCurrentMode("show")

                setshowButton(false)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])



    const PrevRecProcess = async (GsbConfig: CBBCConfig) => {
/*        
        try {
            //console.log("call PrevRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "GsbConfig", cAction: "PrevRec"})
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const DeleteProcess = async (GsbConfig: CBBCConfig) => {
/*        
        try {
            //console.log("call DeleteProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "GsbConfig", cAction: "DelRec"})
            showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const NextRecProcess = async (GsbConfig: CBBCConfig) => {
/*        
        try {
            //console.log("call NextRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "GsbConfig", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }


    const newOnSave = async (GsbConfig: CBBCConfig) => {
/*        
        try {
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "GsbConfig", cAction: "AddRec"})
            showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record added")

            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const editOnSave = async (GsbConfig: CBBCConfig) => {
        try {
            console.log("call editOnSave", GsbConfig)
            const res = await gsb.post('/Master', {sb_data: GsbConfig, cPgmId: "CBBCConfig", cAction: "UpdateRec"})
            //showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record saved")
/*            
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
*/            
            //setCurrentAc(res.data.data)
            showSuccess("CBBC Configuration Record Saved")
            setCurrentAc(res.data.data[0])
            setCurrentMode("show")

        } catch (error) {
            utils.showError(error)
        }
    }



    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    // currentMode = show
    let detail = <CBBCConfigView gsb={gsb} CBBCConfig={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ></CBBCConfigView>
    switch (currentMode) {
        case "edit":
            detail = <CBBCConfigEdit gsb={gsb} CBBCConfig={currentAc} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></CBBCConfigEdit>
            break
        case "new":
            detail = <CBBCConfigEdit gsb={gsb} CBBCConfig={BlankAc} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></CBBCConfigEdit>
            break
    }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>



    let list = <>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>    

    return (
        <>
            <form >
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>CBBC Configuration</H3>
                    {/*
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                    */}

                    {detail}
                </Card>
            </form>
        </>
    );
}

export default CBBCConfigMain